"use strict";Object.defineProperty(exports, "__esModule", {value: true});// src/contracts/dex/v1/constants.ts
var DEX_OP_CODES = {
  SWAP: 630424929,
  PROVIDE_LP: 4244235663,
  DIRECT_ADD_LIQUIDITY: 1291331587,
  REFUND_ME: 200537159,
  RESET_GAS: 1117846339,
  COLLECT_FEES: 533429565,
  BURN: 1499400124
};
var ROUTER_ADDRESS = "EQB3ncyBUTjZUA5EnFKR5_EnOMI9V1tTEAAPaiU71gc4TiUt";




exports.DEX_OP_CODES = DEX_OP_CODES; exports.ROUTER_ADDRESS = ROUTER_ADDRESS;
//# sourceMappingURL=chunk-AZDNTOBW.cjs.map